import * as rfps from './rfp.service';

export default class RfpSellersService {
  baseUrl = '/aptitude/api/rfps';

  constructor(private $http) {
    'ngInject';
  }

  addSeller(requestId: number, sellerId: number) {
    return this.$http.post(`${this.baseUrl}/${requestId}/sellers`, {
      ids: [sellerId], // this currently takes in an array but it will be changed to take a single value
    });
  }

  removeSeller(requestId: number, sellerId: number) {
    return this.$http.delete(
      `${this.baseUrl}/${requestId}/sellers/${sellerId}`,
    );
  }

  getSellerOffers(rfpId: number, sellerId: number): ng.IPromise<any> {
    return this.$http.get(
      `${this.baseUrl}/${rfpId}/sellers/${sellerId}/offers`,
    );
  }

  getPricingComparison(requestId: number, duration: number, priceType: number) {
    return this.$http.get(
      `${this.baseUrl}/${requestId}/sellers/ME/pricingcomparison`,
      {
        params: {
          duration,
          priceType,
        },
      },
    );
  }

  getPricingComparisonForSellerBasedOnSellerTerm(
    requestId: number,
    duration: number,
    priceType: number,
  ) {
    return this.$http.get(
      `${this.baseUrl}/${requestId}/sellers/ME/pricingcomparison`,
      {
        params: {
          duration,
          priceType,
        },
      },
    );
  }

  getProducts(requestId: number, sellerId: number): ng.IPromise<any> {
    return this.$http.get(
      `${this.baseUrl}/${requestId}/sellers/${sellerId}/products`,
    );
  }

  getRfpResponses(rfpId: number): ng.IPromise<any> {
    return this.$http.get(`${this.baseUrl}/${rfpId}/sellers/ME/rfpresponses`);
  }

  getPricingBenchmarks(
    rfpId,
    sellerId,
    memberId,
    priceType,
    duration,
    marketShare,
  ): ng.IPromise<any> {
    return this.$http.get(
      `${this.baseUrl}/${rfpId}/sellers/${sellerId}/pricingbenchmarks`,
      {
        params: {
          partnerId: memberId,
          priceType: priceType,
          duration: duration,
          marketShare: marketShare,
        },
      },
    );
  }

  getPricingBenchmarksWithOfferId(
    rfpId,
    sellerId,
    memberId,
    offerId,
    marketShare,
  ): ng.IPromise<any> {
    return this.$http.get(
      `${this.baseUrl}/${rfpId}/sellers/${sellerId}/pricingbenchmarks`,
      {
        params: {
          partnerId: memberId,
          offerId: offerId,
          marketShare: marketShare,
        },
      },
    );
  }

  submitResponse(rfpId, sellerId, offers: { id: number }[]): ng.IPromise<any> {
    return this.$http.put(
      `${this.baseUrl}/${rfpId}/sellers/${sellerId}/offers`,
      {
        offers: offers,
        responseStatus: 'OfferSubmitted',
      },
    );
  }

  submitOfferResponseWithGraphqlApi(
    rfpId: number,
    offerIds: number[],
  ): ng.IPromise<any> {
    return this.$http.post(`/apt-service/offer/graphql`, {
      query: `mutation submitOffers($input: SubmitOffersRequest!) {
        submitOffers(input: $input) {
          success
        }
      }`,
      operationName: 'submitOffers',
      variables: { input: { rfpId, offerIds } },
    });
  }

  retractResponse(rfpId, sellerId): ng.IPromise<any> {
    return this.$http.put(
      `${this.baseUrl}/${rfpId}/sellers/${sellerId}/offers`,
      {
        responseStatus: 'OfferRetracted',
      },
    );
  }

  getSpend(rfpId: number, sellerId: number): ng.IPromise<rfps.SpendWithSeller> {
    return this.$http.get(`${this.baseUrl}/${rfpId}/sellers/${sellerId}/spend`);
  }
}
